<template>
  <main class="page document-page">
    <div class="document-page__container">
      <ul class="breadcrumbs">
        <li class="breadcrumbs__item">
          <router-link :to="{ name: 'home'}">Главная</router-link>
        </li>
        <li class="breadcrumbs__item">
          <span>Деятельность</span>
        </li>
      </ul>
      <h1 class="document-page__title">Деятельность</h1>
      <div class="document-page__content">
        <div class="document-page__search">
          <i class="document-page__search__icon" aria-hidden="true">
            <search-icon/>
          </i>
          <input class="document-page__search__input" type="text" autocomplete="off" title="Поиск статьи по заголовку" placeholder="Поиск статьи по заголовку" v-model="search"/>
        </div>
        <div class="document-page__table" v-if="search.length === 0">
          <div class="item-list-educational-items">
            <ul>
              <li v-for="(item, index) in $store.state.partitions" :key="index" :class="{ active: activePartition.includes(item.id) }">
                <div class="item-list-educational-header">
                  <button
                    v-if="item.child && item.child.length"
                    :class="{ 'list-arrow-button': true, active: activePartition.includes(item.id) }"
                    type="button"
                    title="Открыть список"
                    @click="toggle(activePartition, item.id)"
                  >
                    <svg fill="none" height="20" viewBox="0 0 12 20" width="12" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10.8975 10.8975C11.3932 10.4018 11.3932 9.59816 10.8975 9.10247L2.81978 1.02473C2.32409 0.529035 1.52042 0.529035 1.02473 1.02473C0.529035 1.52042 0.529035 2.32409 1.02473 2.81978L8.20495 10L1.02473 17.1802C0.529035 17.6759 0.529035 18.4796 1.02473 18.9753C1.52042 19.471 2.32409 19.471 2.81978 18.9753L10.8975 10.8975ZM9 11.2693H10V8.7307H9V11.2693Z" fill="#fff"></path>
                    </svg>
                  </button>
                  <router-link
                    :to="{name: item.id === 8903 ? 'food' : 'partition', params: {id: item.id}}"
                    class="item-list-educational-item">
                    <h4 :title="item.title" class="item-list-educational-title">{{ item.title }}</h4>
                    <div :title="new Date(item.updated_at)" class="item-list-news-date">
                      <time :datetime="item.date_publication" class="item-list-news-date-text">{{
                          item.updated_at | human_date
                        }}
                      </time>
                    </div>
                  </router-link>
                </div>
                <ul v-if="item.child && item.child.length">
                  <li v-for="(child_item, i) in item.child" :key="i" :class="{ active: activePartition.includes(child_item.id) }">
                    <div class="item-list-educational-header">
                      <button
                        v-if="child_item.child && child_item.child.length"
                        :class="{ 'list-arrow-button': true, active: activePartition.includes(child_item.id) }"
                        type="button"
                        title="Открыть список"
                        @click="toggle(activePartition, child_item.id)"
                      >
                        <svg fill="none" height="20" viewBox="0 0 12 20" width="12" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.8975 10.8975C11.3932 10.4018 11.3932 9.59816 10.8975 9.10247L2.81978 1.02473C2.32409 0.529035 1.52042 0.529035 1.02473 1.02473C0.529035 1.52042 0.529035 2.32409 1.02473 2.81978L8.20495 10L1.02473 17.1802C0.529035 17.6759 0.529035 18.4796 1.02473 18.9753C1.52042 19.471 2.32409 19.471 2.81978 18.9753L10.8975 10.8975ZM9 11.2693H10V8.7307H9V11.2693Z" fill="#fff"></path>
                        </svg>
                      </button>
                      <router-link
                        :to="{name: child_item.id === 8903 ? 'food' : 'partition', params: {id: child_item.id}}"
                        class="item-list-educational-item">
                        <h4 :title="child_item.title" class="item-list-educational-title">{{ child_item.title }}</h4>
                        <div :title="new Date(child_item.updated_at)" class="item-list-news-date">
                          <time :datetime="child_item.date_publication" class="item-list-news-date-text">
                            {{ child_item.updated_at | human_date }}
                          </time>
                        </div>
                      </router-link>
                    </div>
                    <ul v-if="child_item.child && child_item.child.length">
                      <li v-for="(subchild_item, i) in child_item.child" :key="i" style="list-style: circle">
                        <router-link
                          :to="{name: subchild_item.id === 8903 ? 'food' : 'partition', params: {id: subchild_item.id}}"
                          class="item-list-educational-item">
                          <h4 :title="subchild_item.title" class="item-list-educational-title">{{ subchild_item.title }}</h4>
                          <div :title="new Date(subchild_item.updated_at)" class="item-list-news-date">
                            <time :datetime="subchild_item.date_publication" class="item-list-news-date-text">
                              {{ subchild_item.updated_at | human_date }}
                            </time>
                          </div>
                        </router-link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="document-page__table" v-else>
          <div class="document-page__table__header">
            <span>Название материала</span>
            <span>Дата публицации</span>
          </div>
          <ul class="document-page__table__body" v-if="partitions.length">
            <li class="document-page__table__item" v-for="(partition, index) in partitions" :key="index">
              <router-link :to="{ name: 'partitionsShow', params: { id: partition.id} }">
                <h2>{{ partition.name }}</h2>
              </router-link>
              <time :datetime="partition.updated_at | robotDate">{{ partition.updated_at | humanDate }}</time>
            </li>
          </ul>
          <span v-else>Статьи в деятельности не найдены</span>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import SearchIcon from 'components/svg/SearchIcon.vue'

export default {
  async asyncData ({ store }) {
    await store.dispatch('PARTITIONS_PAGE')
  },
  name: 'PartitionsPage',
  components: { SearchIcon },
  data () {
    return {
      activePartition: [],
      search: ''
    }
  },
  methods: {
    toggle (array, value) {
      if (array.includes(value)) {
        array.splice(array.indexOf(value), 1)
      } else {
        array.push(value)
      }
    }
  },
  computed: {
    partitions () {
      return this.$store.state.partitions.map(item => item.articles).flat().filter(item => item.name.toLowerCase().includes(this.search.toLowerCase()))
    }
  },
  metaInfo () {
    return this.$seo(
      'common',
      'Деятельность',
      'управление образования, образование',
      '',
      'Деятельность',
      '',
      ''
    )
  }
}
</script>
